import React from 'react';

import PinData from '~/data/sidebar/storage_map.json';
import teamMap from '~/images/storage-map.svg';

const StorageMap = ({ block }) => {
  return (
    <section
      className={`block ${block._template} ${block.css_class_name ? block.css_class_name : ''}`}
    >
      <div className='container'>
        <div className='storage-map-wr'>
          <img
            src={teamMap}
            alt='Team Map - bunny.net'
            title='Team Map - bunny.net'
          />
          <ul className='storage-pins'>
            {PinData.items.map((pin, index) => {
              return (
                <li
                  key={index}
                  className={`pin ${pin.pin_size} ${pin.planned ? ' planned' : ''}`}
                  style={{
                    top: `${pin.map_position_top}`,
                    left: `${pin.map_position_left}`,
                  }}
                >
                  <div className='pin-dot'></div>
                  <div className='label'>
                    {pin.name} {pin.planned && <small>(Planned)</small>}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default StorageMap;
